<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div id="user-maintenance-container">
  <fab-loading-spinner color="primary" *ngIf="showSpinner" id="loading-spinner"></fab-loading-spinner>

  <div id="header-container">
    <div>
      <h1 id="header-text">User Maintenance</h1>
    </div>
    <div>
      <button mat-raised-button color="primary" id="run-gfs-report-button" class="action-button"
              (click)="getUserReport()">
        Run GFS/User Report
      </button>
      <button mat-raised-button color="warn" id="delete-button" class="action-button"
              (click)="deleteUser()" [disabled]="noData || !selectedUser">
        Delete User
      </button>
      <button mat-raised-button color="primary" id="edit-user-button" class="action-button"
              (click)="openEditUser()" [disabled]="noData || !selectedUser">
        Edit User
      </button>
      <button mat-raised-button color="primary" id="add-new-user-button" class="action-button"
              (click)="openAddUser()" [disabled]="noData">
        Add New User
      </button>
    </div>
  </div>
  <div [hidden]="!noData">No users to display!</div>


  <div class="users-div default-padding">
    <mat-card appearance="outlined" class="mat-card-container default-padding" [hidden]="noData">
      <mat-card-title>Users</mat-card-title>

      <div class="gfs-table">
        <ag-grid-angular
          style="height: 100%; width:100%;"
          class="ag-theme-quartz"
          [rowData]="gfsUsers"
          [columnDefs]="userColumns"
          [autoSizeStrategy]="autoSizeStrategy"
          [rowSelection]="rowSelection"
          (rowSelected)="onSelect($event)"
          [rowHeight]="50"
        />
      </div>
    </mat-card>
  </div>
</div>
